var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#7324F0",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.675 13.462V13a3.004 3.004 0 00-2.99 2.784A2.996 2.996 0 0021.705 13v.462A2.538 2.538 0 0124.243 16a2.531 2.531 0 01-2.538 2.538V19a3.004 3.004 0 002.99-2.784A2.997 2.997 0 0027.685 19v-.462A2.538 2.538 0 0125.148 16a2.53 2.53 0 012.527-2.538zM11.643 19v-.344L11.633 16h-.443v3m6.453-6c-1.653 0-3 1.348-3 3s1.347 3 3 3a3 3 0 100-6zm0 5.538a2.538 2.538 0 110-5.075A2.538 2.538 0 0120.18 16a2.531 2.531 0 01-2.537 2.538zM9.538 13c-1.653 0-3 1.348-3 3A2.544 2.544 0 014 18.538V19c1.652 0 3-1.348 3-3a2.544 2.544 0 012.538-2.538h3.855V13H9.538z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStox);
export default __webpack_public_path__ + "static/media/stox.7769f1cf59b807e7ae5b9060d7978b9e.svg";
export { ForwardRef as ReactComponent };